/*
	copyright 2019 wmb

	Aufruf mit zwei Koordinaten einer beliebigen Strecke C ----- A
	C ist der Startpunkt, A ist Waypoint No 1
	Berechnet wird der zugehoerige FAI Sektor zu C-A

     Strecke C-A
	C ---------- A
		   .
		  / \
		 °   °
	   /       \
	   ---------
	   FAI Sektor

	Es gilt, fuer Dreiecke kleiner 500 km
		- darf der kuerzeste Schenkel nicht kuerzer als 28% der Gesamtstrcke sein
	Und es gilt fuer Dreicke groesser gleich 500 km
		- es darf der kuerzeste Schenkel nicht kleiner als 25% und der laengste Schenkel nicht groesse als 45% der Gesamtstrecke sein

	Die Funktion berechnet die einzelnen Abschnitte des Sektors, es sind immer zwischen 3 und 9 Einzelabschnitte.
	nsteps gibt an, wie viele Punkte pro Abschnitt berechnet werden sollen
	Alle Koordinaten aller (!) Teilstuecke eines Sektors landen dann im Array mySectorPointsArr, und mit diesem wird dann woanders
	weiter gearbeitet. Dieser Array ist die Quelle fuer die draw interaction von bspw. Openlayers
*/

const {PI, acos, cos, sin, sqrt} = Math;

const PI_180 = 180 / PI;

// Umrechnen von Radians in Degrees
const radiansToDegrees = radians => radians * PI_180;

// Erdradius
const RE = 6371.0;

//
export default (latC, lonC, latA, lonA) => {
    const mySectorPointsArr = [];

    // Anzahl Zwischenschritte auf jedem Grenzlinienabschnitt beim Plotten
    const nsteps = 20;


    //// Kurswinkel und Streckenlaenge b berechnen

    // Hilfswinkel
    const phC = PI / 2 - latC;
    const phA = PI / 2 - latA;
    const la = lonA - lonC;

    // Streckenlaenge in rad
    const b = acos(cos(phC) * cos(phA) + sin(phC) * sin(phA) * cos(la)); // Seitencosinussatz

    let PsA, PsC;

    // Falluntercheidung, ob Startpunkt oestlich oder westlich von Zielpunkt
    if (lonC < lonA) {
        // Kurswinkel im Startpunkt
        PsC = acos((cos(phA) - cos(phC) * cos(b)) / (sin(phC) * sin(b)));// Seitencosinussatz

        // Kurswinkel im Zielpunkt
        PsA = PI - acos((cos(phC) - cos(phA) * cos(b)) / (sin(phA) * sin(b)));// Seitencosinussatz
    } else {
        // Kurswinkel im Startpunkt
        PsC = -acos((cos(phA) - cos(phC) * cos(b)) / (sin(phC) * sin(b)));// Seitencosinussatz
        // Kurswinkel im Zielpunkt
        PsA = PI + acos((cos(phC) - cos(phA) * cos(b)) / (sin(phA) * sin(b)));// Seitencosinussatz
    }


    // der Anteil, den b bei einem 500km Dreieck am Umfang haette
    const k500 = b / (500 / RE);


    /*
    const p0l = getIntersect_ac(0.28,0.28);
    console.log(p0l.a)

    function getIntersect_ac(ka, kc) {

        const schnittpunktObj = {
            ga: 0,
            al: 0,
            a: 0,
            c: 0
        };

        schnittpunktObj.a = 5;

        return schnittpunktObj;

    }
    */


    //// Berechnung der Schnittpunkte (Eckpunkte des Sektors)
    // Spitze: Schnittpunkt a=0.28U (Trichter klein) mit c=0.28U (Trichter klein)
    const p0l = getIntersect_ac(0.28, 0.28);
    const p0r = getIntersect_ac(0.28, 0.28);
    const kb0 = 1 / (p0l.a + p0l.c + 1);                  // Anteil von b am Umfang

    // Schnittpunkt a=0.28U (Trichter klein)mit b= k500*U (500er Grenze)
    const p1l = getIntersect_ab(0.28, k500);
    const p1r = getIntersect_cb(0.28, k500);

    // Schnittpunkz a=0.25U (Trichter gross) mit b= k500*U (500er Grenze)
    const p2l = getIntersect_ab(0.25, k500);
    const p2r = getIntersect_cb(0.25, k500);

    // Schnittpunkz a=0.25U (Trichter gross) mit c=0.45U (Seitenbegrenzung)
    const p3l = getIntersect_ac(0.25, 0.45);
    const p3r = getIntersect_ac(0.45, 0.25);
    const kb3 = 1 / (p3l.a + p3l.c + 1);                  // Anteil von b am Umfang


    // Schnittpunkt c=0.45U (Seitenbegrenzung) mit b=0.25U (Aussenrand gross)
    const p4l = getIntersect_cb(0.45, 0.25);
    const p4r = getIntersect_ab(0.45, 0.25);


    // Schnittpunkt a=0.28U (Trichter klein) mit c=0.45U (Seitenbegrenzung)
    // const p5l = getIntersect_ac(0.28, 0.45);
    // const p5r = getIntersect_ac(0.45, 0.28);


    // Schnittpunkt b=k500*U (500er Grenze) mit a=0.25U (Trichter gross)
    const p6l = getIntersect_ab(0.25, k500);
    const p6r = getIntersect_cb(0.25, k500);

    // Schnittpunkt b=k500*U (500er Grenze) mit c=0.45U (Seitenbegrenzung)
    const p7l = getIntersect_cb(0.45, k500);
    const p7r = getIntersect_ab(0.45, k500);

    // Schnittpunkt a=0.28U (Trichter klein) mit b=0.28U (Aussenrand klein)
    const p8l = getIntersect_ab(0.28, 0.28);
    const p8r = getIntersect_cb(0.28, 0.28);


    // Schnittpunkt b=0.45U (Innenrand) mit a=0.25U (Trichter gross)
    const p9l = getIntersect_ab(0.25, 0.45);
    const p9r = getIntersect_cb(0.25, 0.45);


    //// zeichnen der einzelnen Sektorgrenzabschnitte
    //// Fall 1: nur grosses Dreieck
    if (k500 > 0.45) {
//		console.log('Fall 1: nur grosses Dreieck');
        // erster Abschnitt: b=0.45*U (Innenrand)
        plot_fbA(0.45, p9l.al, p9r.al);

        // zweiter Abschnitt: a=0.25*U
        plot_faC(0.25, p9l.ga, p3l.ga);
        plot_fcA(0.25, p9r.al, p3r.al);

        // dritter Abschnitt: c=0.45*U (Seitenbegrenzung)
        plot_fcA(0.45, p3l.al, p4l.al);
        plot_faC(0.45, p3r.ga, p4r.ga);

        // vierter Abschnitt: b=0.25*U (Aussenrand)
        plot_fbC(0.25, p4r.ga, p4l.ga);

        //// Fall 2: 500er Grenze definiert schmalst moegliches Dreieck
    } else if (k500 > kb0) {
//		console.log('Fall 2: 500er Grenze definiert schmalst moegliches Dreieck');
        // erster Abschnitt: b=k500*U (Innenrand)
        plot_fbA(k500, p6l.al, p6r.al);

        // zweiter Abschnitt: a=0.25*U
        plot_faC(0.25, p6l.ga, p3l.ga);
        plot_fcA(0.25, p6r.al, p3r.al);

        // dritter Abschnitt: c=0.45*U (Seitenbegrenzung)
        plot_fcA(0.45, p3l.al, p4l.al);
        plot_faC(0.45, p3r.ga, p4r.ga);

        // vierter Abschnitt: b=0.25*U (Aussenrand)
        plot_fbC(0.25, p4r.ga, p4l.ga);


        //// Fall 3: uebergang klein/gross erfolgt von a=0.28U auf a=0.25U
    } else if (k500 > kb3) {
//		console.log('Fall 3: uebergang klein/gross erfolgt von a=0.28U auf a=0.25U');
        // erster Abschnitt: a=0.28*U (kleines Dreieck)
        plot_faC(0.28, p0l.ga, p1l.ga);
        plot_fcA(0.28, p0r.al, p1r.al);

        // zweiter Abschnitt: b=k500*U (500er Grenze)
        plot_fbC(k500, p1l.ga, p2l.ga);
        plot_fbA(k500, p1r.al, p2r.al);

        // dritter Abschnitt: a=0.25*U (grosses Dreieck)
        plot_faC(0.25, p2l.ga, p3l.ga);
        plot_fcA(0.25, p2r.al, p3r.al);

        // vierter Abschnitt: c=0.45*U (Seitenbegrenzung)
        plot_fcA(0.45, p3l.al, p4l.al);
        plot_faC(0.45, p3r.ga, p4r.ga);

        // fuenfter Abschnitt: b=0.25*U (Aussenrand)
        plot_fbC(0.25, p4r.ga, p4l.ga);


        //// Fall 4: uebergang klein/gross erfolgt von a=0.28U auf Seitenbegrenzung (c = 0.45U)
    } else if (k500 > 0.28) {
//		console.log('Fall 4: uebergang klein/gross erfolgt von a=0.28U auf Seitenbegrenzung (c = 0.45U)');
        // erster Abschnitt: a=0.28*U (kleines Dreieck)
        plot_faC(0.28, p0l.ga, p1l.ga);
        plot_fcA(0.28, p0r.al, p1r.al);

        // zweiter Abschnitt: b=k500*U (500er Grenze)
        plot_fbC(k500, p1l.ga, p7l.ga);
        plot_fbA(k500, p1r.al, p7r.al);


        // vierter Abschnitt: c=0.45*U (Seitenbegrenzung)
        plot_fcA(0.45, p7l.al, p4l.al);
        plot_faC(0.45, p7r.ga, p4r.ga);

        // fuenfter Abschnitt: b=0.25*U (Aussenrand)
        plot_fbC(0.25, p4r.ga, p4l.ga);


        //// Fall 5: zweiteiliges Dreieck: uebergang klein/gross erfolgt von jenseits b=0.28 U
    } else if (k500 > 0.25) {
//		console.log('Fall 5: zweiteiliges Dreieck: uebergang klein/gross erfolgt von jenseits b=0.28 U');
        // erster Abschnitt: a=0.28*U (kleines Dreieck)
        plot_faC(0.28, p0l.ga, p8l.ga);
        plot_fcA(0.28, p0r.al, p8r.al);

        // zweiter Abschnitt: b=0.28*U (Aussenrand)
        plot_fbC(0.28, p8r.ga, p8l.ga);

        // dritter Abschnitt: b=k500*U (Innenrand)
        plot_fbA(k500, p7l.al, p7r.al);

        // vierter Abschnitt: c=0.45*U (Seitenbegrenzung)
        plot_fcA(0.45, p7l.al, p4l.al);
        plot_faC(0.45, p7r.ga, p4r.ga);

        // fuenfter Abschnitt: b=0.25*U (Aussenrand)
        plot_fbC(0.25, p4r.ga, p4l.ga);


        //// Fall 6: nur kleines Dreieck
    } else {
//		console.log('Fall 6: nur kleines Dreieck');
        // erster Abschnitt: a=0.28*U (kleines Dreieck)
        plot_faC(0.28, p0l.ga, p8l.ga);
        plot_fcA(0.28, p0r.al, p8r.al);

        // zweiter Abschnitt: b=0.28*U (Aussenrand)
        plot_fbC(0.28, p8r.ga, p8l.ga);

    }


    //// Hilfsfunktionen
    //// Laengenbestimmung
    // Laenge der Kante a fuer a=ka*U
    function faa(ka, ga) {
        return (ka * (1 + cos(ga)) - 1) / (1 - 1 / (2 * ka));
    }

    // Laenge der Kante a fuer b=kb*U
    function fab(kb, ga) {
        return (2 * kb - 1) / (2 * kb * (kb + kb * cos(ga) - 1));
    }

    // Laenge der Kante c fuer b=kb*U
    function fcb(kb, al) {
        return fab(kb, al); // aus Symmetriegruenden die selbe Gleichung
    }

    // Laenge der Kante c fuer c=kc*U
    function fcc(kc, al) {
        return faa(kc, al); // aus Symmetriegruenden die selbe Gleichung
    }

    //// Schnittpunktebestimmung
    // Bestimme Schnittpunkt von a=ka*U und b=kb*U
    function getIntersect_ab(ka, kb) {
        const p = {ga: 0, al: 0, a: 0, c: 0};
        p.ga = acos((2 * ka + 2 * kb - 2 * ka * kb - 1) / (2 * ka * kb));
        p.a = faa(ka, p.ga);
        p.c = sqrt(1 + (p.a * p.a) - 2 * p.a * cos(p.ga));    // cosinussatz
        p.al = acos(((p.c * p.c) + 1 - (p.a * p.a)) / (2 * p.c));
        return p;
    }


    // Bestimme Schnittpunkt von a=ka*U und c=kc*U
    function getIntersect_ac(ka, kc) {
        const p = {ga: 0, al: 0, a: 0, c: 0};
        p.ga = PI - acos((2 * ka * kc - 2 * kc - 2 * ka + 2 * (ka * ka) + 1) / (2 * ka * (ka + kc - 1)));
        p.a = faa(ka, p.ga);
        p.al = PI - acos((2 * kc * ka - 2 * ka - 2 * kc + 2 * (kc * kc) + 1) / (2 * kc * (kc + ka - 1)));
        p.c = fcc(kc, p.al);
        return p;
    }


    // Bestimme Schnittpunkt von b=ka*U und c=kc*U
    function getIntersect_cb(kc, kb) {
        const p = {ga: 0, al: 0, a: 0, c: 0};
        const p_temp = getIntersect_ab(kc, kb);
        p.al = p_temp.ga;
        p.ga = p_temp.al;
        p.c = p_temp.a;
        p.a = p_temp.c;
        return p;
    }


    //// plotten
    // Plote a=ka*U Linie bezogen auf Punkt C (Startpunkt)
    function plot_faC(ka, ga1, ga2) {
        // Schrittweite
        const step = (ga2 - ga1) / nsteps;

        for (let l = 0; l < nsteps + 1; l++) {
            const ga = ga1 + l * step;

            // Laenge a ist noch auf b=1 bezogen und muss mit echtem b skaliert werden
            const a = b * faa(ka, ga);

            // Lat/Lon berechnen
            const koord = polar2LatLon(latC, lonC, a, PsC + ga);

            mySectorPointsArr.push([radiansToDegrees(koord.lon), radiansToDegrees(koord.lat)]);
        }
    }

    // Plote b=kb*U Linie bezogen auf Punkt C (Startpunkt)
    function plot_fbC(kb, ga1, ga2) {
        const step = (ga2 - ga1) / nsteps;

        for (let l = 0; l < nsteps + 1; l++) {
            const ga = ga1 + l * step;
            const a = b * fab(kb, ga);
            const koord = polar2LatLon(latC, lonC, a, PsC + ga);

            mySectorPointsArr.push([radiansToDegrees(koord.lon), radiansToDegrees(koord.lat)]);
        }
    }

    // Plote b=kb*U Linie bezogen auf Punkt A (Aufziehpunkt)
    function plot_fbA(kb, al1, al2) {
        const step = (al2 - al1) / nsteps;

        for (let l = 0; l < nsteps + 1; l++) {
            const al = al1 + l * step;
            const c = b * fcb(kb, al);
            const koord = polar2LatLon(latA, lonA, c, PsA + PI - al);

            mySectorPointsArr.push([radiansToDegrees(koord.lon), radiansToDegrees(koord.lat)]);
        }
    }

    // Plote c=kc*U Linie bezogen auf Punkt A (Aufziehpunkt)
    function plot_fcA(kc, al1, al2) {
        const step = (al2 - al1) / nsteps;
        for (let l = 0; l < nsteps + 1; l++) {
            const al = al1 + l * step;
            const c = b * fcc(kc, al);
            const koord = polar2LatLon(latA, lonA, c, PsA + PI - al);

            mySectorPointsArr.push([radiansToDegrees(koord.lon), radiansToDegrees(koord.lat)]);
        }
    }

    // Umrechnung von Polarkoordinaten bezgl. eines Punktes in lat/lon
    function polar2LatLon(latRef, lonRef, dist, angle) {
        const koord = {lon: 0, lat: 0};

        // Winkel vom Nordpol zu C (Bezugspunkt)
        const phRef = PI / 2 - latRef;

        // Winkel vom Nordpol zu B (zu beschreibender Punkt)
        const ph = acos(cos(phRef) * cos(dist) + sin(phRef) * sin(dist) * cos(angle));  //Seitencosinussatz

        let deltaLon;

        // Laengengraddifferenz zwischen B und C
        // Fallunterschiedung noetig, weil acos mehrdeutig
        if (((angle % (2 * PI)) + 2 * PI) % (2 * PI) > PI) {
            deltaLon = -acos((cos(dist) - cos(phRef) * cos(ph)) / (sin(phRef) * sin(ph)));//Seitencosinussatz
        } else {
            deltaLon = acos((cos(dist) - cos(phRef) * cos(ph)) / (sin(phRef) * sin(ph)));//Seitencosinussatz
        }

        koord.lat = PI / 2 - ph;
        koord.lon = lonRef + deltaLon;

        return koord;
    }

    return mySectorPointsArr;
}
